// this is an autogenerated file from DesignSystem/EditAutomation/TriggerType/OrderStatusChanged/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_EditAutomation_TriggerType_OrderStatusChanged{
  orders_order_statuses(order_by: { value: asc_nulls_last }) {
    id: value
    text: comment
  }
}

`